import {
  Autocomplete,
  Button,
  createTheme,
  NumberInput,
  Pagination,
  Select,
  Table,
  Textarea,
  Switch,
  MultiSelect,
  Checkbox,
  Badge,
  Tabs,
  TextInput,
  Loader,
  SegmentedControl,
} from '@mantine/core';
import {
  DatePickerInput,
  DateTimePicker,
  type DatePickerInputProps,
  type DateTimePickerProps,
} from '@mantine/dates';

const defaultInputStyles = {
  mt: 'sm',
  size: 'lg',
  radius: 10,
};

export const theme = createTheme({
  primaryColor: 'indigo',
  components: {
    Pagination: Pagination.extend({
      defaultProps: {
        size: 'xl',
        color: '#173969',
        radius: 'lg',
      },
    }),
    Button: Button.extend({
      defaultProps: {
        size: 'lg',
        color: '#173969',
        radius: 'md',
      },
    }),
    Select: Select.extend({
      defaultProps: {
        ...defaultInputStyles,
        checkIconPosition: 'right',
      },
    }),
    Autocomplete: Autocomplete.extend({
      defaultProps: defaultInputStyles,
    }),
    DatePickerInput: DatePickerInput.extend({
      defaultProps: defaultInputStyles as Partial<DatePickerInputProps<'default'>>,
    }),
    NumberInput: NumberInput.extend({
      defaultProps: defaultInputStyles,
    }),
    DateTimePicker: DateTimePicker.extend({
      defaultProps: defaultInputStyles as Partial<DateTimePickerProps>,
    }),
    MultiSelect: MultiSelect.extend({
      defaultProps: {
        ...defaultInputStyles,
        checkIconPosition: 'right',
      },
    }),
    Textarea: Textarea.extend({
      defaultProps: {
        ...defaultInputStyles,
        autosize: true,
        minRows: 2,
        maxRows: 4,
      },
    }),
    TextInput: TextInput.extend({
      defaultProps: defaultInputStyles,
    }),
    Table: Table.extend({
      defaultProps: {
        verticalSpacing: 'md',
        striped: true,
        highlightOnHover: true,
        styles: {
          thead: {
            backgroundColor: '#173969',
            color: '#fff',
            height: '50px',
            fontSize: '16px',
            fontWeight: '700',
            borderRadius: '15px',
          },
        },
      },
    }),
    Switch: Switch.extend({
      defaultProps: {
        size: 'xl',
        color: 'orange.7',
      },
    }),
    Checkbox: Checkbox.extend({
      defaultProps: {
        size: 'lg',
        color: 'orange.6',
      },
    }),
    Badge: Badge.extend({
      defaultProps: {
        size: 'lg',
      },
    }),
    Tabs: Tabs.extend({
      defaultProps: {
        color: '#173969',
      },
    }),
    Loader: Loader.extend({
      defaultProps: {
        color: '#173969',
        size: 'lg',
      },
    }),
    SegmentedControl: SegmentedControl.extend({
      defaultProps: {
        size: 'lg',
        radius: 'md',
      },
    }),
  },
  // Add more components as needed
});
